import InPersonJudging from "./InPersonJudging";

export default InPersonJudging;
